import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MediImg from "../../../images/Technology-layout.png";

const Technology = () => {
  const navigate = useNavigate();

  // Hero Section with Background Image
  const HeroSection = () => (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: { xs: "50vh", md: "70vh" },
        backgroundImage: `url(${MediImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
      }}
    >
      {/* Dark Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.45)",
        }}
      />

      {/* Content */}
      <Container
        sx={{
          position: "relative",
          zIndex: 2,
        }}
      >
        <Typography
          variant="overline"
          sx={{
            color: "#fff",
            letterSpacing: 2,
            opacity: 0.9,
          }}
        >
          Specialization
        </Typography>

        <Typography
          variant="h3"
          sx={{
            color: "#fff",
            fontWeight: 700,
            mt: 1,
            mb: 2,
            fontSize: { xs: "1.6rem", md: "2rem" },
          }}
        >
          Technology Solutions
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "rgba(255,255,255,0.85)",
            maxWidth: 600,
            mb: 3,
          }}
        >
          Delivering cutting-edge technology solutions with skilled
          professionals dedicated to driving digital transformation and
          innovation across your organization.
        </Typography>

        <Button
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          sx={{
            backgroundColor: "#1976d2",
            px: 4,
            py: 1.2,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "15px",
            "&:hover": {
              backgroundColor: "#115293",
            },
          }}
          onClick={() => navigate("/contact-us")}
        >
          Get in Touch
        </Button>
      </Container>
    </Box>
  );

  return (
    <Box>
      <HeroSection />

      {/* Technology Jobs Section */}
      <Box
        sx={{
          py: { xs: 6, md: 10 },
          backgroundColor: "#f5f5f5",
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            align="center"
            sx={{
              fontWeight: 700,
              mb: { xs: 6, md: 8 },
              color: "#0a3b4a",
              fontSize: { xs: "2rem", md: "2.4rem" },

            }}
          >
            Technology Jobs
          </Typography>

          {/* Row 1 - 4 columns */}
          <Grid
            container
            spacing={{ xs: 6, md: 8 }}
            sx={{ mb: { xs: 6, md: 10 } }}
          >
            {/* Applications Architect */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Technology
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Applications Architect
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Applications architects require a high level of technical
                  expertise, combined with excellent planning, coordination and
                  communication skills. They design overall application and
                  system architecture, ensure standards are maintained and
                  provide technical leadership to the development team for
                  enterprise-level platforms.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Big Data Engineer */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Technology
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Big Data Engineer
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Big data engineers work with business users and data
                  scientists to translate business requirements into
                  data-processing workflows. They design and implement data
                  pipelines, manage large volumes of structured and unstructured
                  data and build scalable, high-performance data platforms.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Business Intelligence Analyst */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Technology
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Business Intelligence Analyst
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  BI analysts have a strong background in database technology
                  and reporting tools. They design and develop enterprise data
                  analysis and reporting solutions, analyze data from multiple
                  internal and external sources and present insights and
                  recommendations to senior management.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Data Scientist */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Technology
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Data Scientist
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Data scientists combine mathematics, statistics and business
                  acumen to analyze and interpret multiple data sets. They build
                  models, develop metrics and prototypes and provide insights
                  and recommendations that support data-driven decision making
                  and identify opportunities for business growth.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Row 2 - 4 columns */}
          <Grid
            container
            spacing={{ xs: 6, md: 8 }}
            sx={{ mb: { xs: 6, md: 10 } }}
          >
            {/* Data Security Analyst */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Technology
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Data Security Analyst
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Data security analysts understand all aspects of computer and
                  network security, including firewalls, encryption and network
                  protocols. They perform security audits and risk assessments,
                  investigate incidents, recommend improvements and help ensure
                  compliance with security policies and regulations.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Database Administrator */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Technology
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Database Administrator
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  DBAs manage, monitor and maintain company databases. They
                  ensure the integrity, security, stability and availability of
                  data, apply changes and upgrades, optimize performance and
                  maintain backup and recovery infrastructure for critical
                  business systems.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Desktop Support Analyst */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Technology
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Desktop Support Analyst
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Desktop support analysts provide customer service and
                  technical assistance for hardware, software and operating
                  systems. They troubleshoot issues, coordinate with vendors,
                  manage access control based on policies and help ensure
                  reliable end user computing environments.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Front End Developer */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Technology
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Front End Developer
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Front end developers create appealing, user-friendly web and
                  mobile-based interfaces. They use HTML, CSS and JavaScript to
                  build responsive layouts, collaborate with designers and back
                  end teams and ensure consistent branding and usability across
                  browsers and platforms.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Row 3 - 4 columns */}
          <Grid container spacing={{ xs: 6, md: 8 }}>
            {/* Help Desk Technician */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Technology
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Help Desk Technician
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Help desk technicians provide first-line technical support,
                  answering questions, resolving incidents and escalating issues
                  when needed. They require strong communication and
                  problem-solving skills and a solid understanding of the
                  hardware, software and networks being supported.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Information Systems Security Manager */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Technology
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Information Systems Security Manager
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Security managers provide leadership and guidance to security
                  teams, oversee implementation of information security
                  policies, manage security projects and assessments and ensure
                  compliance with legal and regulatory requirements while
                  protecting the organization from security threats.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Mobile Application Developer */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Technology
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Mobile Application Developer
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Mobile application developers design, code, test and maintain
                  mobile apps for phones and tablets. They work with platforms
                  such as iOS and Android, collaborate with designers and back
                  end teams and focus on performance, usability and overall user
                  experience.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Network Architect */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Technology
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Network Architect
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Network architects design and implement complex network
                  infrastructures for corporate data, voice and video. They
                  assess requirements, plan and upgrade network installations,
                  evaluate hardware and software options and make
                  recommendations to improve capacity, security and reliability.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Technology;
